<ng-container [formGroup]="form.formGroup">
  <div [formArrayName]="form.formControlNames.questions"
    *ngFor="let questionControl of form.formGroup.controls.questions.controls; let i = index">
    <app-frat-question-select-form
     class="question-select"
     [formControl]="questionControl">
    </app-frat-question-select-form>
  </div>
</ng-container>
